import EditNote from "@mui/icons-material/EditNote";
import EditOff from "@mui/icons-material/EditOff";
import RateReview from "@mui/icons-material/RateReview";
import { IconButton, Tooltip } from "@mui/material";

import { SCOUT_WRITE_MODE_GQL, type ScoutWriteModeGql } from "../hooks/scoutWriteMode";
import { useScoutWriteAccessControl } from "../hooks/useScoutWriteAccessControl";

export type ScoutWriteAccessIndicatorProps = {
  writeMode: ScoutWriteModeGql;
  onWriteModeChange: (next: ScoutWriteModeGql) => void;
  disabled?: boolean;
};

export function ScoutWriteAccessIndicator({
  writeMode,
  onWriteModeChange,
  disabled = false,
}: ScoutWriteAccessIndicatorProps) {
  const { isFeatureEnabled, cycle, indicatorTooltip, indicatorAriaLabel } =
    useScoutWriteAccessControl({
      writeMode,
      onWriteModeChange,
      disabled,
    });

  if (!isFeatureEnabled) {
    return null;
  }

  let Icon = EditOff;
  if (writeMode === SCOUT_WRITE_MODE_GQL.AUTO) {
    Icon = EditNote;
  } else if (writeMode === SCOUT_WRITE_MODE_GQL.ASK) {
    Icon = RateReview;
  }

  return (
    <Tooltip title={indicatorTooltip} arrow>
      <span
        style={{
          display: "inline-flex",
          cursor: disabled ? "default" : "pointer",
        }}
      >
        <IconButton
          onClick={cycle}
          onMouseDown={(event) => event.preventDefault()}
          disabled={disabled}
          aria-label={indicatorAriaLabel}
          aria-pressed={writeMode !== SCOUT_WRITE_MODE_GQL.OFF}
        >
          <Icon sx={{ fontSize: 20 }} />
        </IconButton>
      </span>
    </Tooltip>
  );
}
